import { FullLayout } from 'scenes/layout';
import { AuthenticationPageContent } from './AuthenticationPageContent';

export const SignUpPage = (): JSX.Element => (
  <FullLayout>
    <AuthenticationPageContent componentKey="sign up page" location="sign up page" />
  </FullLayout>
);
